import invariant from '../tiny-invariant';
import Lifecycle from './Lifecycle';
import RouterContext from './RouterContext';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The public API for prompting the user before navigating away from a screen.
 */
function Prompt({
  message,
  when = true
}) {
  return /*#__PURE__*/_jsx(RouterContext.Consumer, {
    children: context => {
      invariant(context, 'You should not use <Prompt> outside a <Router>');
      if (!when || context.staticContext) return null;
      const method = context.history.block;
      return /*#__PURE__*/_jsx(Lifecycle, {
        onMount: self => {
          // @ts-expect-error stashing release fn on Lifecycle instance — not in its type
          self.release = method(message);
        },
        onUpdate: (self, prevProps) => {
          // @ts-expect-error Lifecycle prevProps doesn't know about the extra 'message' prop
          if (prevProps.message !== message) {
            // @ts-expect-error release fn stashed on Lifecycle instance
            self.release();
            // @ts-expect-error stashing release fn on Lifecycle instance
            self.release = method(message);
          }
        },
        onUnmount: self => {
          // @ts-expect-error release fn stashed on Lifecycle instance
          self.release();
        }
        // @ts-expect-error extra prop passed to Lifecycle so onUpdate can access prevProps.message
        ,
        message: message
      });
    }
  });
}
export default Prompt;